module.exports = __webpack_public_path__ + "img/9788971105092.e671db47.jpg";